import React from 'react';
import { Dialog } from '../Dialog/Dialog';
import { colorPalette } from '../../colorPalette';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/system';
import { dialogClasses } from '@mui/material/Dialog';
import { dialogContentClasses } from '@mui/material/DialogContent';
import { dialogActionsClasses } from '@mui/material';
export const DialogAlert = ({ title, children, open, onClose = () => null, content, dataQa }) => {
    return (React.createElement(Dialog, { sx: {
            [`& .${dialogClasses.paper}`]: { maxWidth: '320px', maxHeight: '192px', borderRadius: '8px', height: 'auto' },
            [`& .${dialogContentClasses.root}`]: { paddingTop: 0, paddingBottom: '8px' },
            [`& .${dialogActionsClasses.root}`]: { paddingTop: '8px' },
        }, withCloseIcon: false, withGoBackIcon: false, withTransition: true, open: open, onClose: onClose, footer: React.createElement(Stack, { direction: "row", spacing: 2, width: '100%' }, children), dataQa: dataQa },
        title ? (React.createElement(Typography, { sx: {
                fontWeight: 600,
                fontSize: '1.6rem',
                color: colorPalette.gray800,
                paddingBottom: '8px',
                position: 'sticky',
                top: 0,
                backgroundColor: 'white',
                paddingTop: '16px',
            } }, title)) : null,
        React.createElement(Typography, { sx: { whiteSpace: 'pre-wrap', overflowWrap: 'break-word' } }, content)));
};
